import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackCreateWishListParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/wishList/trackCreateWishList";

const useTrackCreateWishList = (
    parameters: TrackCreateWishListParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.createWishList, parameters, options);
};

export default useTrackCreateWishList;
